if (!window.cip_SaveAsDialog) {
    window.cip_SaveAsDialog = {};
}

(function () {
	"use strict";
	
	cip_SaveAsDialog.okText = "Save";

	cip_SaveAsDialog.id = function () {
		return 'saveAsDialog';
	};
	
	cip_SaveAsDialog.title = function () {
		return 'Continue Later';
	};
	
	cip_SaveAsDialog.width = function () {
		return 450;
	};
	
	cip_SaveAsDialog.content = function () {
		return 	'<p>' +
					'Please enter the following details' +
				'<p>' +
				'<label id="saveAsEmailLabel">' +
				  	'<span class="emailLabel" style="width:130px;" >Email Address</span>' +
					'<input name="saveAsEmail" class="form-control" type="text" style="width:230px;" />' +
					'<em>*</em>' +
				'</label>'+
				'<label id="saveAsMobilePhoneNumberLabel">'+
					'<span class="mobilePhoneNumberLabel" style="width:130px;">Mobile Phone</span>'+
					'<input name="saveAsMobilePhoneNumber" class="form-control" type="text" style="width:230px;" />'+
					'<em>*</em>'+
				'</label>';
	};	
	
	cip_SaveAsDialog.unpopulate = function (isNew) {
		var saveAs = {};
		
		saveAs.email = $('#' + cip_SaveAsDialog.id() + " input[name=saveAsEmail]").getValue().trim();
		saveAs.mobilePhoneNumber = $('#' + cip_SaveAsDialog.id() + " input[name=saveAsMobilePhoneNumber]").getValue().trim();
		
		return saveAs;
	};
	
	cip_SaveAsDialog.populate = function (saveAs, isNew) {
		$('#' + cip_SaveAsDialog.id() + " input[name=saveAsEmail]").setValue(saveAs.email);
		$('#' + cip_SaveAsDialog.id() + " input[name=saveAsMobilePhoneNumber]").setValue(saveAs.mobilePhoneNumber);
	};
}());